import {
    AfterContentInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ContentChild,
    EventEmitter,
    Input,
    Output,
    SimpleChanges,
    ViewEncapsulation,
} from '@angular/core';

import { CmpsCardBodyComponent } from './card-body.component';
import { CmpsCardHeaderComponent } from './card-header.component';

@Component({
    selector: 'cmps-card-next',
    template: ` <ng-content select="cmps-card-header-next"></ng-content>
        <ng-content select="cmps-card-body-next"></ng-content>`,
    host: {
        class: 'cmps-card-next',
    },
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class CmpsCardComponent implements AfterContentInit {
    @ContentChild(CmpsCardHeaderComponent)
    private readonly _header: CmpsCardHeaderComponent;

    @ContentChild(CmpsCardBodyComponent)
    private readonly _body: CmpsCardBodyComponent;

    @Input() collapsable: boolean;
    @Input() collapsed: boolean;
    @Input() collapseMethod: 'd-none' | 'v-hidden';
    @Output() collapsedChange: EventEmitter<boolean>;

    constructor(private readonly _changeDetectorRef: ChangeDetectorRef) {
        this.collapseMethod = 'd-none';
        this.collapsedChange = new EventEmitter();
    }

    ngOnChanges(_: SimpleChanges): void {
        this._check();
    }

    ngAfterContentInit(): void {
        this._check();
    }

    ngOnDestroy(): void {
        this.collapsedChange.complete();
    }

    collapse(): void {
        if (!this.collapsable) {
            return;
        }
        this.collapsed = true;
        this._check();
    }

    expand(): void {
        if (!this.collapsable) {
            return;
        }
        this.collapsed = false;
        this._check();
    }

    private _check(): void {
        const onCollapseChange = (): void => {
            this.collapsed = !this.collapsed;
            this._header.collapsed = this.collapsed;
            this._body.collapsed = this.collapsed;
            this._body.collapseMethod = this.collapseMethod;
            this.collapsedChange.emit(this.collapsed);
        };

        if (this._header != null) {
            this._header.collapsable = this.collapsable;
            this._header.collapsed = this.collapsed;
            this._header._onCollapseChange = onCollapseChange;
        }

        if (this._body != null) {
            this._body.collapsed = this.collapsed;
            this._body.collapseMethod = this.collapseMethod;
        }
    }
}
